import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Grid: FunctionComponent<Props> = ({
    children,
    className = '',
    dataExpanded,
    onClick,
    onKeyDown,
    ref,
    role,
    style,
    tabIndex,
    testId = TEST_ID
}) => (
    <div
        className={`${className} ${styles.grid}`}
        data-expanded={dataExpanded}
        data-testid={testId}
        onClick={onClick}
        onKeyDown={onKeyDown}
        ref={ref}
        role={role}
        style={style}
        tabIndex={tabIndex}>
        {children}
    </div>
);

export default Grid;
